<template>
  <div>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <label class="label">по клиенту {{client.name}}</label>
          <tabs type="boxed">
          <tab-pane label="Пользователи">
          <div class="table-responsive">
            <table class="table is-bordered is-striped is-narrow">
              <tbody>
              <tr v-for="user in users">
                <td>
                  <a :href="'#/users/'+user.id">{{user.username}}</a>
                  <!--<a :href="'#/calltasks/parameters/'+calltask.id">{{calltask.phone}}</a>-->
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <p class="control">
            <button class="button is-light" v-on:click="cancel">
            <span class="icon">
              <i class="fa fa-times-circle"></i>
            </span>
              <span>Закрыть</span>
            </button>
          </p>
          </tab-pane>
          <tab-pane v-if="canAccessAdditionalParameters(permissionKey)" label="Client Config">
          <div class="table-responsive">
            <table class="table is-bordered is-striped is-narrow">
              <thead>
                <tr>
                  <th>Ключ</th>
                  <th>Значение</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(param, index) in clientConfigArray">
                  <td v-if="param[0]!='activeScenarioTemplates' && param[0]!='defaultPhonePreprocessingStrategyParameters'">
                    <input v-model="param[0]" class="input" type="text" readonly>
                  </td>
                  <td v-if="param[0]!='activeScenarioTemplates' && param[0]!='defaultPhonePreprocessingStrategyParameters'">
                    <input v-if="param[1]!=null" v-model="param[1]" class="input" type="text" :readonly="!canEdit()">
                    <input v-if="param[1]==null" v-model="param[1]" class="input" placeholder="Параметр не указан" type="text" :readonly="!canEdit()">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

            <div class="table-responsive">
              <table class="table is-bordered is-striped is-narrow">
                <thead>
                <tr>
                  <th colspan="3">Phone Preprocessing Parameters</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(param, index) in phonePreprocessingParametersArray">
                  <td>
                    <input v-model="param[0]" class="input" type="text" :readonly="!canEdit()">
                  </td>
                  <td>
                    <input v-model="param[1]" class="input" type="text" :readonly="!canEdit()">
                  </td>
                  <td>
                    <button class="button is-light" v-on:click="deletePhonePreprocessingParameter(index)" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-minus-circle"></i>
                      </span>
                      <span>Удалить</span>
                    </button>
                  </td>
                </tr>
                <tr>
                  <td><button class="button is-light" v-on:click="addPhonePreprocessingParameter" style="width:100%">
                      <span class="icon">
                        <i class="fa fa-plus-circle"></i>
                      </span>
                    <span>Добавить</span>
                  </button></td>
                  <td></td>
                  <td></td>
                </tr>
                </tbody>
              </table>
            </div>

          <div class="table-responsive">
            <table class="table is-bordered is-striped is-narrow">
              <thead>
                <tr>
                  <th colspan="2">Active Scenario Templates</th>
                </tr>
                <tr>
                <th>Scenario Template</th>
                <th>Activity</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(param, index) in activeScenarioTemplatesArray">
                <td>
                  <input v-model="param[0]" class="input" type="text" readonly>
                </td>
                <td>
                  <input v-model="param[1]" class="input" type="text" :readonly="!canEdit()">
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <p class="control">
            <button  v-if="canEdit()" class="button is-primary" v-on:click="save(true)">
              <span class="icon">
                <i class="fa fa-floppy-o"></i>
              </span>
              <span>Сохранить</span>
            </button>
            <button class="button is-light" v-on:click="cancel">
              <span class="icon">
                <i class="fa fa-times-circle"></i>
              </span>
              <span>Закрыть</span>
            </button>
          </p>
          </tab-pane>
          </tabs>
        </article>
      </div>
    </div>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex'
  import Notification from 'vue-bulma-notification'
  import { Tabs, TabPane } from 'vue-bulma-tabs'
  import Vue from 'vue'
  import CheckToken from '../authentication/CheckToken'
  import CheckPermission from '../authentication/CheckPermission'

  Vue.mixin(CheckToken)
  Vue.mixin(CheckPermission)

  const NotificationComponent = Vue.extend(Notification)
  const openNotification = (propsData = {
    title: '',
    message: '',
    type: '',
    direction: '',
    duration: 4500,
    container: '.notifications'
  }) => {
    return new NotificationComponent({
      el: document.createElement('div'),
      propsData
    })
  }

  const USERS_API = '/api/users'
  const CLIENTS_API = '/api/clients'

  export default {
    props: ['id'],
    components: {
      Notification,
      Tabs,
      TabPane
    },
    data () {
      return {
        users: [],
        client: '',
        permissionKey: 'client',
        clientConfigArray: [
          {
            key: '',
            value: ''
          }
        ],
        activeScenarioTemplatesArray: [
          {
            key: '',
            value: ''
          }
        ],
        phonePreprocessingParametersArray: [
          {
            key: '',
            value: ''
          }
        ]
      }
    },
    created: function () {
      this.checkToken()
      this.users = this.loadData()
      this.loadClient()
    },
    computed: {
      ...mapGetters([
        'authenticationToken',
        'loggedId'
      ])
    },
    methods: {
      prepareSecurityHeader() {
        console.log(this.authenticationToken)
        return {
          Authorization: `Bearer ${this.authenticationToken}`
        }
      },
      loadApplications () {
          this.loadData()
      },
      loadData () {
        this.$http.get(USERS_API + '/getUsersByClient/' + this.$props.id, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.users = response.data
          })
          .catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка загрузки информации о пользователях. ')
          })
      },
      loadClient () {
        this.$http.get(CLIENTS_API + '/getClient/' + this.$props.id, {headers: this.prepareSecurityHeader()})
          .then((response) => {
            this.client = response.data
            this.clientConfigArray = Object.entries(this.client.clientConfig)
            this.activeScenarioTemplatesArray = []
            for (let i = 0; i < this.clientConfigArray.length; i++) {
              if (this.clientConfigArray[i][0] === 'activeScenarioTemplates') {
                this.activeScenarioTemplatesArray = Object.entries(Object.entries(this.client.clientConfig)[i][1])
              }
            }
            this.phonePreprocessingParametersArray = Object.entries(this.client.clientConfig.defaultPhonePreprocessingStrategyParameters)
          })
          .catch((error) => {
            console.log(error)
            this.openNotificationWithType('danger', 'Ошибка загрузки данных клиента. ')
          })
      },
      save (showMessage) {
        this.client.clientConfig = {}
        for (let i = 0; i < this.clientConfigArray.length; i++) {
          let item = this.clientConfigArray[i]
          this.client.clientConfig[item[0]] = item[1]
        }
        this.client.clientConfig.activeScenarioTemplates = {}
        for (let i = 0; i < this.activeScenarioTemplatesArray.length; i++) {
          let item = this.activeScenarioTemplatesArray[i]
          this.client.clientConfig.activeScenarioTemplates[item[0]] = item[1]
        }
        this.client.clientConfig.defaultPhonePreprocessingStrategyParameters = {}
        for (let i = 0; i < this.phonePreprocessingParametersArray.length; i++) {
          let item = this.phonePreprocessingParametersArray[i]
          this.client.clientConfig.defaultPhonePreprocessingStrategyParameters[item[0]] = item[1]
        }
        this.update(showMessage)
      },
      update (showMessage) {
        console.log('updating client config: ' + JSON.stringify(this.client))
        this.$http.put(CLIENTS_API, this.client, { headers: this.prepareSecurityHeader() })
          .then((response) => {
            if (showMessage) {
              this.openNotificationWithType('info', 'Параметры клиента сохранены.')
            }
          }).catch((error) => {
          console.log(error)
          this.openNotificationWithType('danger', 'Ошибка сохранения данных клиента. ')
        })
      },
      canEdit() {
        return true
      },
      cancel () {
        // this.$router.push('/clients/' + this.$props.id)
        this.$router.push('/clients')
      },
      deletePhonePreprocessingParameter(index) {
        this.phonePreprocessingParametersArray.splice(index, 1)
      },
      addPhonePreprocessingParameter() {
        this.phonePreprocessingParametersArray.push({})
      },
      openNotificationWithType (type, message, duration) {
        openNotification({
          title: 'Уведомление',
          message: message,
          type: type,
          duration: duration
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ClientParameters.vue?82e6c252